<template>
	<div class="content-block">
		<h2>Create a new page</h2>
	</div>
	<PageSettings :page="newPageObj" :group="groupRef" v-if="newPageObj !== null" @created="createdPage"/>
	<div class="content-block group-loading" v-if="newPageObj === null">
		<DxLoadPanel :visible="fatalError === null" container=".group-loading" />
		<div class="dx-error-message" v-if="fatalError !== null">
			<i class="dx-icon-warning"></i><div class="dx-error-message-text">{{ fatalError }}</div>
		</div>
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, nextTick, inject, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import PageSettings from '../components/page-settings';
import GroupCache from '@/groups';

const route = useRoute();
const router = useRouter();
const newPageObj = ref(null);
const groupRef = ref(null);
const fatalError = ref(null);

// Watch for route changes (and also immediately once mounted) to initialize our PageSettings component with group data.
watch( () => [route.params.groupRef],
	async ([newGroupRef]) => {
		newPageObj.value = null; groupRef.value = null; fatalError.value = null;
		await GroupCache.waitForData();
		const group = GroupCache.getBySlug(newGroupRef);
		if (!group) {
			console.error("Group not found for slug:", newGroupRef);
			fatalError.value = `The group described by "${newGroupRef}" was not found. Please refresh the page and try again.`;
			return;
		}
		newPageObj.value = {};
		groupRef.value = group;
	},
	{ immediate: true }
);

// When page is created, we need to refresh our group cache / menu, and redirect to the layout editing page once loading is complete.
function createdPage(returnPageObj) {
	GroupCache.fetchGroupList();
	GroupCache.waitForData().then(() => {
		router.push(`/layout/${groupRef.value.slug}/${returnPageObj.slug}`);
	});
}

</script>